import { Typography } from "@joonapp/web-shared"
import toast from "react-hot-toast"
import { useTranslation } from "react-i18next"

import { useInventoryGiftShopModalStore } from "./hooks/useInventoryGiftShopModalStore"
import { useUserQuery } from "../../../../networking/queries"
import { ShopItem as ShopItemType } from "../../../../types"
import { getShopItemText } from "../../../../util/util"

interface ShopItemProps {
  shopItem: ShopItemType
}

const ShopItem = ({ shopItem }: ShopItemProps) => {
  const { user } = useUserQuery()
  const { setSelectedShopItem, selectedShopItem } =
    useInventoryGiftShopModalStore()
  const { t } = useTranslation()

  const userHasEnoughCoins = shopItem.price <= (user?.coins ?? 0)

  const onClick = () => {
    if (userHasEnoughCoins) setSelectedShopItem(shopItem)
    else {
      toast.dismiss()
      toast.error(t("MAIL_NOT_ENOUGH_COINS"))
    }
  }

  return (
    <button onClick={onClick}>
      <div
        className={`flex flex-row justify-start gap-2 bg-white p-2 rounded-md border items-center text-left ${
          selectedShopItem?.id === shopItem.id
            ? `border-primary shadow-md`
            : `border-borderPrimary`
        } ${userHasEnoughCoins ? "opacity-100" : "opacity-50"}`}
      >
        <img
          className="w-1/5 max-w-[50px] h-[50px] object-contain"
          src={shopItem.image_url}
          alt="Gift"
        />
        <div className="flex flex-col items-start justify-start gap-1">
          <div className="flex flex-row items-center justify-between w-full">
            <Typography
              variant="bodySmallBold"
              style={{ lineHeight: "1.25rem" }}
            >
              {shopItem.name}
            </Typography>
            <div className="flex flex-row items-center justify-end gap-1 w-fit">
              <img
                src="/images/icons/coin-icon.png"
                alt="coin"
                style={{ width: "16px" }}
              />
              <Typography variant="bodySmall">{shopItem.price}</Typography>
            </div>
          </div>
          <Typography variant="bodySmall" style={{ lineHeight: "1.25rem" }}>
            {shopItem.description + " "}
            {getShopItemText(shopItem)}
          </Typography>
        </div>
      </div>
    </button>
  )
}

export default ShopItem
